import Vue from 'vue'
import App from './App.vue'
import router from './router'
import DataLayer from './data-layer'
import store from './store'
import LozadDirective from './assets/js/directives/lozad'
import './libs/rudderstack'
import '../node_modules/normalize.css/normalize.css'

/**
 * Dynamically import the FontAwesomeIcon component
 */
Vue.component(
  'FontAwesomeIcon',
  () => import(/* webpackChunkName: "fonts" */ '@/libs/fontawesome')
)

/**
 * Vue Config
 */
Vue.config.productionTip = false
Vue.config.devtools = (process.env.VUE_APP_ENABLE_VUE_DEV_TOOLS || 'false') === 'true' || false
Vue.use(DataLayer)
Vue.prototype.$store = store

/**
 * Global Event Bus
 * @desc used to transmit events between components
 * @example this.$bus.$emit('event')
 * @example this.$bus.$on('event', () => {})
 */
const bus = new Vue({})
Object.defineProperty(Vue.prototype, '$bus', {
  get () {
    return bus
  }
})

new Vue({
  data: () => ({ store }),
  router,
  render: h => h(App)
}).$mount('#app')

LozadDirective.install()
